export const checkUniqueReferenceNumber = (collectPayment, paymentModeFormReferenceNumber, paymentMode, indexToEdit) => {
 
    let error = false;
    collectPayment.forEach((item, index) => {
        if (item?.paymentMode == paymentMode && (item?.referenceNumber?.value??item?.referenceNumber) == paymentModeFormReferenceNumber && index !== indexToEdit) {
            error = true;
            return
        }
    })
    return error;
}

export const checkBalanceAmount=(paymentModeForm,balanceAmount,errorMgs)=>{
    if(paymentModeForm?.paidAmount > balanceAmount) {
        return true
    }
    else return false;
}
